import _sfc_main from './UiCopyToClipboard.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-ui-copy-to-clipboard" }, [_vm._t("root", function() {
    return [_vm._t("message(success)", function() {
      return [_setup.showSuccessMessage ? _c("div", { class: _setup.copyResultMessageStyle }, [_vm._t("message(success):content", function() {
        return [_vm._v(_vm._s(_setup.translate("uiCopyToClipboard.successMessage")))];
      }, null, { localizationSupport: _setup.localizationSupport, label: "uiCopyToClipboard.successMessage" })], 2) : _vm._e()];
    }, null, { localizationSupport: _setup.localizationSupport, label: "uiCopyToClipboard.successMessage" }), _vm._t("message(failure)", function() {
      return [_setup.showFailureMessage ? _c("div", { class: _setup.copyResultMessageStyle }, [_vm._t("message(failure):content", function() {
        return [_vm._v(_vm._s(_setup.translate("uiCopyToClipboard.failureMessage")))];
      }, null, { localizationSupport: _setup.localizationSupport, label: "uiCopyToClipboard.failureMessage" })], 2) : _vm._e()];
    }, null, { localizationSupport: _setup.localizationSupport, label: "uiCopyToClipboard.failureMessage" }), _vm._t("button", function() {
      return [_c("button", { staticClass: "fds-ui-copy-to-clipboard__btn", attrs: { "type": "button", "aria-label": _setup.translate("uiCopyToClipboard.copy", { value: String(_vm.value) }) }, on: { "click": _setup.copyToClipboard } }, [_c("span", { staticClass: "fds-ui-icon fds-ui-icon--copy" })])];
    }, null, { localizationSupport: _setup.localizationSupport, label: "uiCopyToClipboard.copy" })];
  }, null, { localizationSupport: _setup.localizationSupport })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/ui-copy-to-clipboard/UiCopyToClipboard.vue";
var UiCopyToClipboard = __component__.exports;

export { UiCopyToClipboard as default };
